import React from "react";
import { NAV_ORTU } from "@/lib/nav";
import { BukuDigitalReadonlyList, BukuDigitalReader } from "@/pages/pustaka/BukuDigitalShared";

export function PerpustakaanOrtu() {
  return <BukuDigitalReadonlyList nav={NAV_ORTU} basePath="/ortu/perpustakaan" title="Perpustakaan — Buku Digital" />;
}

export function BacaBukuDigitalOrtu() {
  return <BukuDigitalReader nav={NAV_ORTU} backPath="/ortu/perpustakaan" />;
}
